export default __webpack_public_path__ + "static/media/mission-failed.1587ea0d.webp";